
export default {
  name: 'AppFilterResetButton',
  props: {
    iconHeight: { type: Number, default: 16 },
    iconWidth: { type: Number, default: 16 }
  }
};
